<template>
  <div
    v-if="loading"
    class="retail-page-lock"
    :class="{ 'is-contained': contained }"
    aria-live="polite"
  >
    <div class="retail-page-lock-box">
      <div class="retail-page-loader" aria-hidden="true"></div>
      <div class="retail-page-lock-copy">
        <strong>{{ message || $t('retailSale.loading.message') }}</strong>
        <small>{{ $t('retailSale.loading.pleaseWait') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RetailSalePageLoadingMask',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    contained: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped src="../../styles/page-loading-mask.css"></style>
